/* eslint-disable no-param-reassign */
import { ACTION_TYPE, GETTER_TYPE, MUTATION_TYPE } from './types'
import messagesApi from '@/api/messages'

export default {
  state: {
    chats: [],
    messages: [],
    contact: {},
    unreadChats: null,
    // messages pagination
    pagesMessages: 0,
    currentPageMessages: 1,
    totalMessages: 0,
    perPageMessages: 20,
    // chats pagination
    pagesChats: 0,
    currentPageChats: 1,
    totalChats: 0,
    perPageChats: 10
  },
  mutations: {
    [MUTATION_TYPE.setChats]: (state, chats) => {
      state.chats = chats
    },
    [MUTATION_TYPE.setMessages]: (state, messages) => {
      if (state.currentPageMessages > 1) {
        messages.forEach((el) => state.messages.unshift(el))
      } else {
        state.messages = messages.reverse()
      }
    },
    [MUTATION_TYPE.addMessages]: (state, message) => {
      state.messages.unshift(message)
    },
    [MUTATION_TYPE.setContact]: (state, contact) => {
      state.contact = contact
    },
    [MUTATION_TYPE.setUnreadChats]: (state, unreadChats) => {
      state.unreadChats = unreadChats
    },
    // messages
    [MUTATION_TYPE.setCurrentPageMessages]: (state, page) => {
      state.currentPageMessages = page
    },
    [MUTATION_TYPE.setTotalMessages]: (state, total) => {
      state.totalMessages = total
    },
    [MUTATION_TYPE.setPagesMessages]: (state, pages) => {
      state.pagesMessages = pages
    },
    // chats
    [MUTATION_TYPE.setCurrentPageChats]: (state, page) => {
      state.currentPageChats = page
    },
    [MUTATION_TYPE.setTotalChats]: (state, total) => {
      state.totalChats = total
    },
    [MUTATION_TYPE.setPagesChats]: (state, pages) => {
      state.pagesChats = pages
    },
    [MUTATION_TYPE.clearMessages]: (state) => {
      state.pagesMessages = 0
      state.currentPageMessages = 1
      state.totalMessages = 0
      state.pagesChats = 0
      state.currentPageChats = 1
      state.chats = []
      state.messages = []
      state.contact = {}
    }
  },
  actions: {
    [ACTION_TYPE.fetchChats]: ({ commit, state }, filters) => new Promise((resolve, reject) => {
      messagesApi.fetchChats(filters, state.currentPageChats,
        state.perPageChats).then(({ data }) => {
        commit(MUTATION_TYPE.setChats, data.docs)
        commit(MUTATION_TYPE.setPagesChats, data.pages)
        commit(MUTATION_TYPE.setTotalChats, data.total)
        resolve()
      }).catch((error) => {
        reject(error)
      })
    }),
    [ACTION_TYPE.fetchMessages]: ({ commit, state }, payload) => new Promise((resolve, reject) => {
      messagesApi.fetchMessages(payload.chatId, payload.search,
        state.perPageMessages, state.currentPageMessages).then(({ data }) => {
        commit(MUTATION_TYPE.setMessages, data.messages.docs)
        commit(MUTATION_TYPE.setPagesMessages, data.messages.pages)
        commit(MUTATION_TYPE.setTotalMessages, data.messages.total)
        commit(MUTATION_TYPE.setContact, data.companion)
        resolve()
      }).catch((error) => {
        reject(error)
      })
    }),
    [ACTION_TYPE.techSupportRequest]: (context, form) => new Promise((resolve) => {
      messagesApi.techSupportRequest(form).then(() => {
        resolve()
      }).catch((error) => {
        resolve(error.response)
      })
    }),
    [ACTION_TYPE.fetchUnreadChats]: ({ commit }) => new Promise((resolve, reject) => {
      messagesApi.fetchUnreadChats().then(({ data }) => {
        commit(MUTATION_TYPE.setUnreadChats, data.count)
        resolve()
      }).catch((error) => {
        reject(error)
      })
    }),
    [ACTION_TYPE.makeMessagesRead]: (context, senderId) => messagesApi.makeChatRead(senderId),
    // messages
    [ACTION_TYPE.changePageMessages]: ({ commit }, page) => {
      commit(MUTATION_TYPE.setCurrentPageMessages, page)
    },
    // chats
    [ACTION_TYPE.changePageChats]: ({ commit }, page) => {
      commit(MUTATION_TYPE.setCurrentPageChats, page)
    },
    [ACTION_TYPE.clearMessages]: ({ commit }) => {
      commit(MUTATION_TYPE.clearMessages)
    }
  },
  getters: {
    [GETTER_TYPE.getMessages]: (state) => state.messages,
    [GETTER_TYPE.getChats]: (state) => state.chats,
    [GETTER_TYPE.getContact]: (state) => state.contact,
    [GETTER_TYPE.getUnreadChats]: (state) => state.unreadChats,
    // messages
    [GETTER_TYPE.getPagesMessages]: (state) => state.pagesMessages,
    [GETTER_TYPE.getTotalMessages]: (state) => state.totalMessages,
    [GETTER_TYPE.getCurrentPageMessages]: (state) => state.currentPageMessages,
    // chats
    [GETTER_TYPE.getPagesChats]: (state) => state.pagesChats,
    [GETTER_TYPE.getTotalChats]: (state) => state.totalChats,
    [GETTER_TYPE.getCurrentPageChats]: (state) => state.currentPageChats
  }
}
